import { OP } from '@/types';

import type { FilterOption } from './utils/get-option-text';

export type { FilterOption };

export interface Resource {
  key: string;
  options?: FilterOption[];
  loading?: boolean;
}

interface BaseFilter {
  key: string;
  op?: OP;
  label: string;
  /** 是否隐藏，不在下拉菜单中显示，但参与 transformValues 转换 */
  hidden?: boolean;
}

interface InputFilter extends BaseFilter {
  type: 'input';
  defaultSearch?: boolean;
}

interface SelectFilter extends BaseFilter {
  type: 'select';
}

interface MultipleSelectFilter extends BaseFilter {
  type: 'multiple-select';
}

interface ArraySchema {
  key: string;
  type: 'schema-array';
  op?: OP[];
}

interface ValueSchema {
  key: string;
  type: 'schema-value';
  op?: OP;
}

type Filters = InputFilter | SelectFilter | MultipleSelectFilter;
type Schemas = ArraySchema | ValueSchema;

export type TagFilter = Filters | Schemas;
export type TagFilterType = Filters['type'];

/** 类型守卫 */
export const isFilters = (filter: TagFilter): filter is Filters => {
  const isTagFilter = (type: string): type is TagFilterType => {
    return ['input', 'select', 'multiple-select'].includes(type);
  };

  return 'type' in filter && isTagFilter(filter.type);
};
